import React from 'react';
import { SvgProps } from './types';
import { Svg } from '.';
import { Colors } from '../Colors';

export const IconCheck = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M5 11.9l5.8 5.8L21.1 4.4l-2.3 1.1-8 10.4L6 11.3 5 12z" />
  </Svg>
);

export const IconQuestion = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M3 12a9 9 0 1 1 18 0 9 9 0 1 1-18 0z" fill="#ED4040" />
    <path
      d="M11.7 14.4l.6-.4c-.3-.2-.4-.6-.4-.8 0-1.6 3-1.7 3-4 0-1.3-1-2.4-2.8-2.4-1.5 0-2.6.7-3.2 1.6l.5.6A3 3 0 0 1 12 7.6c1.4 0 2 .8 2 1.6 0 1.9-2.9 2-2.9 4 0 .4.2.8.6 1.2zm.2 2.8c.3 0 .6-.4.6-.7 0-.4-.3-.7-.6-.7-.4 0-.7.3-.7.7 0 .3.3.7.7.7z"
      fill="#fff"
    />
  </Svg>
);

export const IconQuestionStroke = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="7.5" stroke="currentColor" fill="none" />
    <path d="M11.3 13.8h.9v-.1c0-1 .3-1.4 1-1.8.6-.4 1-1 1-1.9 0-1.2-.8-2.1-2.2-2.1-1.3 0-2.3.8-2.4 2.1h1c0-1 .7-1.3 1.4-1.3s1.3.5 1.3 1.3c0 .6-.3 1-.8 1.3-.8.5-1.2 1-1.2 2.4zm.5 2.3c.3 0 .7-.4.7-.7 0-.4-.4-.7-.7-.7-.4 0-.7.3-.7.7 0 .3.3.7.7.7z" />
  </Svg>
);

export const IconPreloader = (props: SvgProps) => (
  <Svg viewBox="0 0 44 44" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth={2}>
      <circle cx={22} cy={22} r={1}>
        <animate
          attributeName="r"
          begin="0s"
          dur="1.8s"
          values="1; 20"
          calcMode="spline"
          keyTimes="0; 1"
          keySplines="0.165, 0.84, 0.44, 1"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-opacity"
          begin="0s"
          dur="1.8s"
          values="1; 0"
          calcMode="spline"
          keyTimes="0; 1"
          keySplines="0.3, 0.61, 0.355, 1"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx={22} cy={22} r={1}>
        <animate
          attributeName="r"
          begin="-0.9s"
          dur="1.8s"
          values="1; 20"
          calcMode="spline"
          keyTimes="0; 1"
          keySplines="0.165, 0.84, 0.44, 1"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-opacity"
          begin="-0.9s"
          dur="1.8s"
          values="1; 0"
          calcMode="spline"
          keyTimes="0; 1"
          keySplines="0.3, 0.61, 0.355, 1"
          repeatCount="indefinite"
        />
      </circle>
    </g>
  </Svg>
);

export const IconArrowLeft = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
  </Svg>
);

export const IconClose = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M12 12.8l-6 6L5 18l6-6-6-6L6 5l6 6 6-6 .9.9-6 6 6 6-.9.9-6-6z" />
  </Svg>
);

export const IconCloseM = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" strokeWidth="2" />
  </Svg>
);

export const IconCopy = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M8 5C7.45 5 7 5.45 7 6V17H8V6H17V5H8ZM10.5385 7C9.69231 7 9 7.73125 9 8.625V18.375C9 19.2688 9.69231 20 10.5385 20H17.4615C18.3077 20 19 19.2688 19 18.375V8.625C19 7.73125 18.3077 7 17.4615 7H10.5385ZM10 19V8H18V19H10Z" />
  </Svg>
);

export const IconDropdown = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M4.6 8.4l.8-.8 6.1 6 6-6 1 .8-7 7-7-7z" />
  </Svg>
);

export const IconCalendar = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M15 4v2h-3V4h-1v2H8V4H7v2H4v13h15V6h-3V4h-1zM5 18v-7h13v7H5zm13-8H5V7h2v1h1V7h3v1h1V7h3v1h1V7h2v3z" />
  </Svg>
);

export const IconEyeClosed = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <g fill="none" stroke="currentColor">
      <path d="M4 9s1.8 4.4 8.5 4.5C19.2 13.6 21 9 21 9" />
      <path opacity=".7" d="M12.5 14v3" />
      <path d="M16.5 13.5l.8 2.9M19.5 12l1.7 2.5M8.5 13.5l-.8 2.9M5.5 12l-1.7 2.5" />
    </g>
  </Svg>
);

export const IconEyeOpen = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <g fill="none" stroke="currentColor">
      <path d="M4 13s1.8-5.4 8.5-5.5A8.5 8.5 0 0 1 21 13" />
      <path opacity=".7" d="M12.5 8V5" />
      <path d="M16.5 8.5l.8-2.9M19.5 10l1.7-2.5M8.5 8.5l-.8-2.9M5.5 10L3.8 7.5M4 13s1.8 4.4 8.5 4.5c6.7.1 8.5-4.5 8.5-4.5" />
    </g>
    <path fillRule="evenodd" d="M9.2 11.3a1.5 1.5 0 1 0 2-2 3.5 3.5 0 1 1-2 2z" />
  </Svg>
);

export const IconExcel = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M13 20l-9-1.5v-13L13 4v2h6c.6 0 1 .5 1 1v10c0 .6-.5 1-1 1h-6v2zm0-3h6V7h-6v1h1v2h-1v1h1v2h-1v1h1v2h-1v1zm-2-8.5L9.1 12l1 1.8.8 1.7-1.5-.1-.4-.8-.7-1.8-.6 1.5-.4 1H6l.6-1.2 1-2-.9-2-.6-1.3h1.4l.3.6.7 1.8.7-1.8c0-.3.2-.6.3-.8l1.4-.1zm7-.5h-3v2h3V8zm-3 3h3v2h-3v-2zm3 3h-3v2h3v-2z"
    />
  </Svg>
);

export const IconEdit = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M15.1 3.8l.4-.3a3.5 3.5 0 0 1 5 5l-.4.3L10 18.9l-6.5 1.5L5 14 15.1 3.7zm.6.9l1.5 2 2 1.5.5-.5a2.5 2.5 0 0 0-3.5-3.5l-.5.5zm2.8 4.2L17 7.7l-8.7 8.7 1.7 1.2L18.5 9zM5.8 15l-1 4 4-.9-1.7-1.3L5.8 15zm.5-1L15 5.5 16.2 7l-8.7 8.7-1.2-1.6z"
    />
  </Svg>
);

export const IconMenu = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M3 8V6h18v2H3zm0 5h18v-2H3v2zm0 5h18v-2H3v2z" />
  </Svg>
);

export const IconSorting = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M3 6v2h18V6H3zm0 12h6v-2H3v2zm12-5H3v-2h12v2z" />
  </Svg>
);

export const IconAgreement = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="m15 15h-12v1h12zm0-8h-12v1h12zm-12 5h18v-1h-18zm0 8h18v-1h-18zm0-17v1h18v-1z" />
  </Svg>
);

export const IconPlus = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M13 6h-2v5H6v2h5v5h2v-5h5v-2h-5V6z" />
  </Svg>
);

export const IconMinus = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M6 11h12v2H6v-2z" />
  </Svg>
);

export const IconPlusThin = (props: SvgProps) => (
  <Svg viewBox="0 0 9 9" {...props}>
    <g strokeWidth="1" stroke="currentColor">
      <line x1="0" y1="4.5" x2="9" y2="4.5" />
      <line x1="4.5" y1="0" x2="4.5" y2="9" />
    </g>
  </Svg>
);

export const IconMinusThin = (props: SvgProps) => (
  <Svg viewBox="0 0 9 9" {...props}>
    <line x1="0" y1="4.5" x2="9" y2="4.5" strokeWidth="1" stroke="currentColor" />
  </Svg>
);

export const IconDecline = (props: SvgProps) => (
  <Svg viewBox="0 0 80 80" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 40C0 17.909 17.909 0 40 0s40 17.909 40 40-17.909 40-40 40S0 62.091 0 40z"
      fill="#ED4040"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5 41.698L27.417 53.784l-1.697-1.697L37.803 40 25.72 27.916l1.697-1.697L39.5 38.304l12.083-12.085 1.697 1.697L41.197 40 53.28 52.087l-1.697 1.697L39.5 41.698z"
      fill="#fff"
    />
  </Svg>
);

export const IconAccept = (props: SvgProps) => (
  <Svg viewBox="0 0 80 80" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 40C0 17.909 17.909 0 40 0s40 17.909 40 40-17.909 40-40 40S0 62.091 0 40z"
      fill="#33B327"
    />
    <path
      d="M21.334 43.812L34.904 57l24.763-32.377L56.5 22.5l-22 28.552L24 41l-2.666 2.812z"
      fill="#EBF7E9"
    />
  </Svg>
);

export const IconInfo = (props: SvgProps) => (
  <Svg viewBox="0 0 80 80" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 40C0 17.909 17.909 0 40 0s40 17.909 40 40-17.909 40-40 40S0 62.091 0 40z"
      fill="#3187EE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.13 29.35l3.645-.18 1.8-6.03-4.05.225-1.395 5.985zm-4.905 19.71c-1.71 6.435 2.07 8.505 13.185 3.96l-.405-1.935c-9.09 2.295-10.26 1.44-9.225-2.61l3.767-14.716-3.105-.045-9.27 2.295.225 1.89 7.965-1.08-3.137 12.241z"
      fill="#fff"
    />
  </Svg>
);

export const IconAcceptM = (props: SvgProps) => (
  <Svg viewBox="0 0 90 90" {...props}>
    <g fill="#3BA900" fillRule="evenodd" clipRule="evenodd">
      <path d="M5 45a40 40 0 1 0 80 0 40 40 0 0 0-80 0zm-5 0a45 45 0 1 1 90 0 45 45 0 0 1-90 0z" />
      <path d="M39.5 67.5l33.4-43.7-5-2.7-29.2 38.2-13.1-12.8-4.5 3.2 18.4 17.8z" />
    </g>
  </Svg>
);

export const IconDeclineM = (props: SvgProps) => (
  <Svg viewBox="0 0 90 90" {...props}>
    <g fill="#ED4040" fillRule="evenodd" clipRule="evenodd">
      <path d="M27.2 30.8l3.6-3.6 32 32-3.6 3.6-32-32z" />
      <path d="M62.8 30.8l-3.6-3.6-32 32 3.6 3.6 32-32z" fill="#ED4040" />
      <path d="M5 45a40 40 0 1 0 80 0 40 40 0 0 0-80 0zm-5 0a45 45 0 1 1 90 0 45 45 0 0 1-90 0z" />
    </g>
  </Svg>
);

export const IconExchange = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
      fillRule="nonzero"
    />
  </Svg>
);

export const IconHistory = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="m13 3c-4.97 0-9 4.03-9 9h-3l3.89 3.89.07.14 4.04-4.03h-3c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42c1.63 1.63 3.87 2.64 6.36 2.64 4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08v-4.25z"
      fillRule="nonzero"
    />
  </Svg>
);

export const IconSecurity = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="m22 18h-6v-4h-2.68c-1.14 2.42-3.6 4-6.32 4-3.86 0-7-3.14-7-7s3.14-7 7-7c2.72 0 5.17 1.58 6.32 4h10.68v6h-2zm-4-2h2v-4h2v-2h-10.06l-.23-.67c-.7-1.99-2.6-3.33-4.71-3.33-2.76 0-5 2.24-5 5s2.24 5 5 5c2.11 0 4.01-1.34 4.71-3.33l.23-.67h6.06zm-11-2c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" />
  </Svg>
);

export const IconPassport = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M5.8 1h14.4c.5 0 .8.4.8.8v18.4c0 .4-.3.8-.8.8H5.8a.8.8 0 01-.8-.8V1.8c0-.4.3-.8.8-.8z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M9 17h8v1H9zM8 14h10v2H8z" />
    <rect x="10" y="4" width="6" height="6" rx="3" />
  </Svg>
);

export const IconSupport = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="m21 10.5c0-4.68771525-3.8122847-8.5-8.5-8.5-4.68771525 0-8.5 3.81228475-8.5 8.5 0 4.5209858 3.55636776 8.2580466 8.0518265 8.4913439l.9481735.0492066v2.95661c4.7949089-2.3103015 8-6.9496824 8-11.4971605zm-9 13.09v-3.6c-5.01-.26-9-4.42-9-9.49 0-5.24 4.26-9.5 9.5-9.5s9.5 4.26 9.5 9.5c0 4.95-3.44 9.93-8.57 12.4z" />
    <path d="m12.608 12.41c-.378-.322-.546-.714-.546-1.134 0-1.778 2.534-1.932 2.534-3.416 0-.7-.546-1.302-1.652-1.302-1.05 0-1.708.462-2.226 1.148l-.7-.756c.672-.868 1.708-1.428 3.038-1.428 1.708 0 2.744.966 2.744 2.17 0 2.114-2.716 2.296-2.716 3.668 0 .224.14.504.378.686zm.294 2.73c-.42 0-.77-.35-.77-.77s.35-.77.77-.77.77.35.77.77-.35.77-.77.77z" />
  </Svg>
);

export const IconWallets = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <g fillRule="nonzero" transform="translate(3 3)">
      <path d="M18 4.28V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2.28A2 2 0 0 0 19 12V6a2 2 0 0 0-1-1.72zM17 6v6h-7V6zM2 16V2h14v2h-6a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h6v2z" />
      <circle cx="13" cy="9" r="1.5" />
    </g>
  </Svg>
);

export const IconLogin = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M5 3h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4h1v5h16V4H4v5H3V5a2 2 0 0 1 2-2zm7.5 12l-1.41-.41L13.67 12H3v-1h10.67l-2.58-2.59L12.5 8l3.5 3.5z"
      fill="#0B5ACD"
    />
  </Svg>
);

export const IconLogout = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M16 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-4h-1v5H3V4h14v5h1V5a2 2 0 0 0-2-2zm4.5 12l-1.41-.41L21.67 12H11v-1h10.67l-2.58-2.59L20.5 8l3.5 3.5z"
      fill={props.color ?? '#ed4040'}
    />
  </Svg>
);

export const IconLocker = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M16 8a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-6a4 4 0 0 1 4-4V4a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v4zM6 8h8V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v4z"
      fill="#ED4040"
    />
  </Svg>
);

export const IconCapture = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4z" />
    <path d="M7.2 4L9 2h6l1.8 2H20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h3.2zM7 12a5 5 0 1 0 10 0 5 5 0 0 0-10 0z" />
  </Svg>
);

export const IconSearch = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M14.7 14h.8l5 5-1.5 1.5-5-5v-.8l-.3-.3a6.5 6.5 0 1 1 .7-.7l.3.3zM5 9.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0z" />
  </Svg>
);

export const IconArrowDown = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M5 8l7.5 7L20 8" fill="none" stroke="currentColor" strokeWidth="2" />
  </Svg>
);

export const IconArrowDownThin = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M1.7 9.4l.6-.8 9.7 8.7 9.7-8.7.6.8L12 18.7 1.7 9.4z" />
  </Svg>
);

export const IconInfoM = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 5v2h2V7h-2zm0 4v6h2v-6h-2zm-7 1a8 8 0 1 0 16 0 8 8 0 0 0-16 0z"
    />
  </Svg>
);

export const IconInfoSign = (props: SvgProps) => (
  <Svg viewBox="0 0 16 16" {...props}>
    <path d="M8.2 4.4l1.2-.1.6-2-1.3.2-.5 1.9zM6.6 11c-.6 2.2.7 2.9 4.4 1.3l-.1-.6c-3 .8-3.4.5-3.1-.9L9 5.9H8l-3.1.8.1.6 2.7-.4L6.6 11z" />
  </Svg>
);

export const IconQuestionSign = (props: SvgProps) => (
  <Svg viewBox="0 0 16 16" {...props}>
    <path d="M4.9 4.4a3 3 0 0 1 1.4-1.1c.5-.3 1.2-.4 1.9-.4.9 0 1.6.2 2.1.7.5.4.8 1 .8 1.7l-.2.8-.4.7-.6.4-.6.5-.5.4-.5.4-.1.6.1.4.3.3-.9.4c-.4-.3-.6-.7-.6-1.2l.2-.8.5-.6.6-.5.7-.5.5-.5.2-.7c0-.4-.2-.7-.5-1C9 4.1 8.6 4 8 4c-.5 0-1 .1-1.3.3l-1.1.9-.7-.8zm2.5 8.5c-.2-.2-.2-.4-.2-.6l.2-.6c.2-.2.4-.2.6-.2l.6.2c.2.2.2.4.2.6l-.2.6c-.2.2-.4.2-.6.2s-.4 0-.6-.2z" />
  </Svg>
);

export const IconBankCard = (props: SvgProps) => (
  <Svg viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M18 1.9H2a2 2 0 0 0-2 2v12c0 1 .9 2 2 2h16a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2zm0 14H2v-6h16v6zM2 5.9h16v-2H2v2z"
      fill="#ED4040"
    />
  </Svg>
);

export const IconWireTransfer = (props: SvgProps) => (
  <Svg viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M.6 4l9.5-4 9.5 4v2H.6V4zm2 4v7h3V8h-3zm6 0v7h3V8h-3zm11 9v3H.6v-3h19zm-5-9v7h3V8h-3z"
      fill="#ED4040"
    />
  </Svg>
);

export const IconUT = (props: SvgProps) => (
  <Svg viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M11.1 17.3v-15h3.2v10.9c0 2.2-1 3.5-3.2 4zm-5.9-4.1v-11h3.2v15c-2-.5-3.2-1.8-3.2-4zM2.5 0v12.6c0 4.4 3 7.4 7 7.4 4.5 0 7.5-3 7.5-7.4V0H2.5z"
      fill="#ED4040"
    />
  </Svg>
);

export const IconProfile = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M7 7a5 5 0 1 0 10 0A5 5 0 0 0 7 7zm5 3a3 3 0 0 0 3-3 3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3zm0 6c-4 0-6.8 2.3-7 3h14c-.2-.7-2-3-7-3zm-9 5v-2c0-2.7 5-5 9-5 5 0 9 2.3 9 5v2H3z"
    />
  </Svg>
);

export const IconKyc = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M3 3h18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm0 16h18V5H3v14z" />
    <path d="M5 10h9v2H5zM5 7h9v2H5z" />
  </Svg>
);

export const IconFilter = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M21 4.4a.7.7 0 0 0-.7-.4H3.7a.7.7 0 0 0-.5 1.2l6.4 6.4c.2.2.3.5.3.7v6.2l.2.5 2.8 2.8a.7.7 0 0 0 1.2-.5v-9c0-.2.1-.5.3-.7l6.4-6.4c.2-.2.3-.5.1-.8z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
  </Svg>
);

export const IconShare = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M12 4a7.49 7.49 0 0 1 7.35 6.04A4.98 4.98 0 0 1 19 20H6a6 6 0 0 1-.65-11.96A7.5 7.5 0 0 1 12 4zM6 18h13a2.98 2.98 0 1 0 .22-5.96l-1.53-.11-.3-1.5A5.5 5.5 0 0 0 7.13 8.97l-.5.95-1.07.11A4 4 0 0 0 6 18z" />
    <path d="M13.45 10h-2.9v3H8l4 4 4-4h-2.55v-3z" />
  </Svg>
);

export const IconStatusPlaced = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M6 6V5h11v1h-1v1.1c0 1-.6 2-1.5 2.6l-3 1.8-3-1.8A3 3 0 0 1 7 7V6H6zm10 11v-1.1c0-1-.6-2-1.5-2.6l-3-1.8-3 1.8A3 3 0 0 0 7 16V17H6v1h11v-1h-1zm-1 0v-1.1a2 2 0 0 0-1-1.7l-2.5-1.5L9 14.2c-.6.4-1 1-1 1.7V17h7zM8 6v1h7V6H8z"
      fill="#0B5ACD"
    />
  </Svg>
);

export const IconStatusPartFilled = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M17 18v1H6v-1h1v-1.1c0-1 .6-2 1.5-2.6l3-1.8 3 1.8A3 3 0 0 1 16 17V18h1zM7 7v1.1c0 1 .6 2 1.5 2.6l3 1.8 3-1.8A3 3 0 0 0 16 8V7h1V6H6v1h1zm1 0v1.1a2 2 0 0 0 1 1.7l.3.2h4.4l.3-.2c.6-.4 1-1 1-1.7V7H8zm6.8 9a2 2 0 0 0-.8-.8l-2.5-1.5L9 15.2a2 2 0 0 0-.8.8h6.6z"
      fill="#0B5ACD"
    />
  </Svg>
);

export const IconStatusRejected = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      d="M15.87 16.58a6 6 0 0 1-8.46-8.46l8.46 8.46zm.71-.7L8.13 7.41a6 6 0 0 1 8.46 8.46zM12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14z"
      fill="#F80"
    />
  </Svg>
);

export const IconArrowRight = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M16.2 12l-7-7.1-1.4 1.4 5.7 5.7-5.7 5.7 1.4 1.4 7-7.1z" />
  </Svg>
);

export const IconLegendGraphColumn = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path fill="none" stroke="currentColor" d="M14 8.5h4v7h-4v-7zm-8-3h4v13H6v-13z" />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth=".5"
      d="M15.8 5.3h.5v3.5h-.5V5.3zm0 10h.5v3.5h-.5v-3.5zm-8 3h.5v3.5h-.5v-3.5zm0-16h.5v3.5h-.5V2.3z"
    />
  </Svg>
);

export const IconLegendGraphWave = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M20.1 11.7c-1.1 1.3-2.7 2.8-4.7 2.8-1 0-1.8-.3-2.4-.8-.6-.5-1-1.1-1.3-1.6 0-.1-.1-.1-.1-.2-.3-.5-.6-.9-.9-1.2-.3-.3-.7-.5-1.3-.5-.6 0-1.2.3-2 .8-.7.3-1.4 1-2.1 1.7-.6.7-1.2 1.4-1.6 1.9-.2.3-.4.5-.5.6-.1.1-.1.1-.1.2l-.4-.3-.4-.3s.1-.1.1-.2c.1-.2.3-.4.5-.6.4-.5 1-1.2 1.7-2 .7-.7 1.5-1.4 2.3-2 .8-.5 1.7-1 2.5-1 .9 0 1.5.3 2 .8.4.4.7.9 1 1.4 0 .1.1.1.1.2.3.5.7 1 1.1 1.4.4.3 1 .6 1.7.6 1.6 0 2.9-1.1 3.9-2.4.5-.6.9-1.2 1.2-1.7l.3-.6c0-.1.1-.1.1-.2l.5.2.5.3s0 .1-.1.2-.2.4-.3.6c-.4.5-.8 1.2-1.3 1.9z" />
  </Svg>
);

export const IconTrash = (props: SvgProps) => (
  <Svg viewBox="0 0 13 16" {...props}>
    <g stroke="currentColor" fill="transparent">
      <path clipRule="evenodd" d="M8.5 6.5l-4 4 4-4zM8.5 10.5l-4-4 4 4z" />
      <path d="M2.44 14.13L1.54 3.5h9.92l-.9 10.63a1.5 1.5 0 01-1.5 1.37H3.94a1.5 1.5 0 01-1.5-1.37z" />
      <path strokeWidth=".5" d="M.25 1.25h12.5v.5H.25zM4.25.25h4.5v.5h-4.5z" />
    </g>
  </Svg>
);

export const IconExclamationMark = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M13 4H11V15H13V4ZM13 17H11V19H13V17Z" />
  </Svg>
);

export const IconVisa = (props: SvgProps) => (
  <Svg viewBox="0 0 61 30" {...props}>
    <path
      d="M31 11.4c0 2.7 2.5 4.2 4.3 5 1.9 1 2.5 1.6 2.5 2.4 0 1.3-1.5 1.8-2.9 1.8-2.4 0-3.8-.6-5-1.2l-.8 4.2c1 .5 3.2 1 5.4 1 5 0 8.4-2.6 8.4-6.5 0-5-6.8-5.2-6.8-7.4 0-.7.7-1.4 2-1.6.8 0 2.7-.1 4.8.9l.9-4a13 13 0 00-4.5-.8c-4.8 0-8.2 2.5-8.2 6.2M52 5.5c-1 0-1.7.5-2 1.4l-7.4 17.4h5.1l1-2.8H55l.6 2.8H60L56 5.5zm.7 5l1.5 7.1h-4zM25 5.6l-4 18.8h4.8l4-18.8zm-7.2 0l-5 12.8-2-10.9c-.3-1.2-1.3-1.9-2.3-1.9H0L0 6c1.7.4 3.6 1 4.8 1.6.7.4 1 .8 1.1 1.7l4 15h5l7.9-18.8z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
  </Svg>
);

export const IconMastercard = (props: SvgProps) => (
  <Svg viewBox="0 0 118 30" {...props}>
    <path
      d="M67.15 12.66v6.22H65.8v-.75c-.43.56-1.08.9-1.97.9-1.74 0-3.1-1.36-3.1-3.26 0-1.9 1.36-3.26 3.1-3.26.89 0 1.54.35 1.97.9v-.75zM64 13.78c-1.17 0-1.88.9-1.88 2 0 1.08.71 1.98 1.88 1.98 1.12 0 1.88-.86 1.88-1.99s-.76-1.99-1.88-1.99zm48.83 2c0-1.1.72-2 1.89-2 1.12 0 1.87.86 1.87 2 0 1.12-.75 1.98-1.87 1.98-1.17 0-1.89-.9-1.89-1.99zm5.04-5.61V18.88h-1.36v-.75c-.43.56-1.08.9-1.96.9-1.74 0-3.11-1.36-3.11-3.26 0-1.9 1.37-3.26 3.11-3.26.88 0 1.53.35 1.96.9v-3.24zm-33.94 3.55c.87 0 1.43.54 1.57 1.5h-3.22c.14-.9.69-1.5 1.65-1.5zm-3.07 2.05c0-1.94 1.27-3.26 3.1-3.26 1.74 0 2.94 1.32 2.95 3.26 0 .18-.01.35-.03.52h-4.61c.19 1.12.98 1.52 1.85 1.52.63 0 1.3-.23 1.81-.65l.67 1c-.76.64-1.62.88-2.55.88-1.86 0-3.19-1.3-3.19-3.27zm19.42 0c0-1.1.72-1.99 1.89-1.99 1.11 0 1.87.86 1.87 2 0 1.12-.76 1.98-1.87 1.98-1.17 0-1.89-.9-1.89-1.99zm5.03-3.1v6.21h-1.35v-.75c-.43.56-1.08.9-1.96.9-1.75 0-3.11-1.36-3.11-3.26 0-1.9 1.36-3.26 3.1-3.26.9 0 1.54.35 1.97.9v-.75zm-12.66 3.1c0 1.89 1.3 3.27 3.31 3.27.94 0 1.56-.21 2.24-.74l-.65-1.1c-.5.37-1.04.56-1.63.56-1.08-.01-1.87-.8-1.87-1.99s.8-1.97 1.87-1.99c.59 0 1.12.2 1.63.56l.65-1.1a3.26 3.26 0 00-2.24-.73c-2 0-3.31 1.38-3.31 3.26zm15.78-2.35c.36-.55.86-.91 1.64-.91.28 0 .67.05.97.17l-.42 1.27a2.2 2.2 0 00-.85-.15c-.88 0-1.32.57-1.32 1.6v3.48h-1.36v-6.22h1.34zm-34.6-.26a4.65 4.65 0 00-2.53-.65c-1.57 0-2.59.75-2.59 1.99 0 1.01.76 1.64 2.15 1.83l.64.1c.74.1 1.09.3 1.09.64 0 .48-.5.76-1.42.76-.94 0-1.61-.3-2.07-.65l-.64 1.05c.75.55 1.68.8 2.7.8 1.8 0 2.83-.84 2.83-2.02 0-1.1-.82-1.67-2.17-1.86l-.64-.1c-.58-.07-1.05-.19-1.05-.6 0-.46.44-.73 1.18-.73.8 0 1.56.3 1.94.53zm15.81.26c.35-.55.86-.91 1.64-.91.27 0 .66.05.96.17l-.42 1.27a2.2 2.2 0 00-.84-.15c-.89 0-1.33.57-1.33 1.6v3.48H88.3v-6.22h1.34zm-9.9-.76h-2.2v-1.88h-1.38v1.88H74.9v1.24h1.26v2.84c0 1.44.56 2.3 2.16 2.3.59 0 1.27-.18 1.7-.48l-.4-1.16c-.4.23-.84.35-1.2.35-.67 0-.89-.42-.89-1.04V13.9h2.21zm-20.21 2.32v3.9h-1.37v-3.46c0-1.05-.44-1.64-1.36-1.64-.9 0-1.53.58-1.53 1.65v3.45h-1.36v-3.46c0-1.05-.46-1.64-1.35-1.64-.93 0-1.53.58-1.53 1.65v3.45h-1.36v-6.22h1.35v.77c.5-.73 1.16-.92 1.82-.92.95 0 1.63.41 2.06 1.1a2.4 2.4 0 012.18-1.1c1.51.01 2.45 1 2.45 2.47z"
      clipRule="evenodd"
      fillRule="evenodd"
    />
    <path d="M16.48 15.05c0-4.16 1.95-7.87 4.98-10.26a13.05 13.05 0 100 20.52 13.03 13.03 0 01-4.98-10.26" />
    <path
      d="M42.58 15.05A13.05 13.05 0 0121.46 25.3a13.03 13.03 0 000-20.52 13.05 13.05 0 0121.11 10.26"
      opacity=".4"
    />
    <path
      d="M21.46 25.3a13.03 13.03 0 000-20.51 13.03 13.03 0 000 20.52zm0-20.51z"
      clipRule="evenodd"
      fillRule="evenodd"
      opacity=".6"
    />
  </Svg>
);

export const IconOrderOk = (props: SvgProps) => (
  <Svg viewBox="0 0 36 36" {...props}>
    <path
      d="M18 0a18 18 0 100 36 18 18 0 000-36zm9.3 11L16.2 25.4l-6.1-6 1.4-1 4.4 4.3L25.7 10l1.6 1z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Svg>
);

export const IconOrderAlert = (props: SvgProps) => (
  <Svg viewBox="0 0 36 36" {...props}>
    <path
      d="M18 0a18 18 0 100 36 18 18 0 000-36zm-1 21V10h2v11h-2zm0 4v-2h2v2h-2z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Svg>
);

export const IconWarning = (props: SvgProps) => (
  <Svg viewBox="0 0 36 30" {...props}>
    <path
      d="M16.285 2.85831C17.0618 1.56363 18.9382 1.56363 19.715 2.85831L34.1826 26.971C34.9824 28.3041 34.0222 30 32.4676 30H3.53238C1.97779 30 1.01757 28.3041 1.81739 26.971L16.285 2.85831Z"
      fill={Colors.ut.warning}
    />
    <path
      d="M16.7002 22.36C16.7002 23.08 17.2852 23.665 18.0052 23.665C18.7252 23.665 19.2952 23.08 19.2952 22.36C19.2952 21.625 18.7252 21.055 18.0052 21.055C17.2852 21.055 16.7002 21.625 16.7002 22.36ZM18.8152 19.005L19.2952 11H16.7152L17.1802 19.005H18.8152Z"
      fill={Colors.text.default}
    />
  </Svg>
);

export const IconGear = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      d="M13.5406 2.73995C13.2694 2.69214 13.0379 3.02489 12.7959 3.3728C12.5307 3.75391 12.2529 4.15321 11.8965 4.09036L11.9492 4.09966L11.9206 4.0999C11.6288 4.05503 11.3895 3.71103 11.1596 3.38069C10.9176 3.03279 10.6861 2.70004 10.4149 2.74785C10.1438 2.79566 10.0401 3.18752 9.9316 3.59723C9.81278 4.04605 9.68829 4.51628 9.33187 4.57913L9.37588 4.57137L9.34918 4.5814C9.06146 4.63267 8.7224 4.39374 8.39669 4.16421C8.05024 3.92008 7.71889 3.68658 7.48045 3.82424C7.24202 3.9619 7.27856 4.36561 7.31676 4.78771C7.35862 5.25009 7.40247 5.73455 7.08903 5.91551L7.14333 5.88416L7.12403 5.90063C6.87248 6.06345 6.46214 5.95218 6.06832 5.84539C5.65927 5.73447 5.26804 5.62838 5.09106 5.83929C4.91409 6.0502 5.0865 6.41707 5.26677 6.80064C5.46425 7.22083 5.67114 7.66107 5.43851 7.93832L5.48234 7.88608L5.47037 7.90713C5.29197 8.15098 4.86506 8.18704 4.45546 8.22164H4.45545C4.03313 8.25731 3.62921 8.29143 3.53504 8.55015C3.44088 8.80887 3.72837 9.09464 4.02896 9.39343C4.32566 9.68835 4.63512 9.99597 4.60289 10.3028C4.52829 10.6021 4.13225 10.7853 3.75255 10.961C3.36789 11.139 3 11.3092 3 11.5845C3 11.8598 3.36789 12.03 3.75255 12.208C4.14151 12.388 4.5476 12.5758 4.60776 12.8884L4.5794 12.8104C4.70318 13.1505 4.35819 13.4934 4.02891 13.8208C3.72833 14.1195 3.44083 14.4053 3.535 14.664C3.62916 14.9228 4.03309 14.9569 4.45541 14.9925C4.88244 15.0286 5.32829 15.0663 5.49172 15.3393L5.43852 15.2759C5.67116 15.5532 5.46426 15.9934 5.26679 16.4136C5.08652 16.7972 4.9141 17.164 5.09108 17.375C5.26805 17.5859 5.65928 17.4798 6.06834 17.3688C6.48185 17.2567 6.91357 17.1396 7.16057 17.3401L7.08903 17.2988C7.40247 17.4798 7.35862 17.9642 7.31676 18.4266C7.27856 18.8487 7.24202 19.2524 7.48045 19.3901C7.71889 19.5278 8.05024 19.2943 8.39669 19.0501C8.74687 18.8033 9.11248 18.5457 9.41314 18.6495L9.33188 18.6352C9.68831 18.6981 9.81279 19.1683 9.93161 19.6171C10.0401 20.0268 10.1438 20.4187 10.415 20.4665C10.6861 20.5143 10.9176 20.1815 11.1597 19.8336C11.4044 19.4819 11.6599 19.1146 11.9781 19.1096L11.8965 19.1239C12.2529 19.0611 12.5307 19.4604 12.7959 19.8415C13.0379 20.1894 13.2695 20.5222 13.5406 20.4743C13.8117 20.4265 13.9155 20.0347 14.0239 19.625C14.1336 19.2108 14.2481 18.7783 14.5453 18.6647L14.4736 18.706C14.7871 18.5251 15.1847 18.8053 15.5642 19.0727C15.9107 19.3168 16.242 19.5503 16.4805 19.4127C16.7189 19.275 16.6823 18.8713 16.6441 18.4492C16.6055 18.0226 16.5652 17.5771 16.8054 17.3687L16.7524 17.4318C16.9851 17.1546 17.4545 17.2819 17.9026 17.4034C18.3117 17.5143 18.7029 17.6204 18.8799 17.4095C19.0569 17.1986 18.8844 16.8317 18.7042 16.4482C18.5219 16.0604 18.3316 15.6555 18.4863 15.3774L18.458 15.4552C18.5818 15.1151 19.0665 15.0741 19.5291 15.0351C19.9514 14.9994 20.3553 14.9653 20.4495 14.7066C20.5437 14.4478 20.2562 14.1621 19.9556 13.8633C19.6517 13.5612 19.3344 13.2458 19.3846 12.9316V12.9692C19.3846 12.9489 19.386 12.9292 19.3887 12.9099C19.3928 12.8909 19.3982 12.8719 19.4051 12.8529L19.3923 12.8882C19.4526 12.5758 19.8586 12.388 20.2475 12.2081C20.6321 12.0301 21 11.8599 21 11.5846C21 11.3092 20.6321 11.139 20.2475 10.9611C19.8261 10.7661 19.3846 10.5619 19.3846 10.2V10.2817L19.3837 10.2768C19.3384 9.96455 19.6536 9.65121 19.9556 9.351C20.2562 9.05221 20.5437 8.76644 20.4495 8.50772C20.3554 8.249 19.9514 8.21488 19.5291 8.17921C19.0665 8.14014 18.5818 8.0992 18.458 7.7591L18.4813 7.82303L18.4689 7.80191C18.3473 7.52552 18.5294 7.13799 18.7042 6.76617C18.8844 6.3826 19.0568 6.01573 18.8799 5.80482C18.7029 5.59391 18.3117 5.7 17.9026 5.81092C17.4545 5.93243 16.985 6.05974 16.7524 5.78249L16.7922 5.82996L16.7717 5.81299C16.5692 5.59312 16.6074 5.17065 16.6441 4.76516C16.6823 4.34306 16.7189 3.93935 16.4805 3.80169C16.242 3.66403 15.9107 3.89753 15.5642 4.14166C15.1847 4.4091 14.7871 4.6893 14.4736 4.50834L14.5121 4.53055L14.4852 4.52103C14.232 4.37524 14.1259 3.97441 14.0239 3.58933C13.9154 3.17962 13.8117 2.78776 13.5406 2.73995ZM5.50384 15.3503L5.50606 15.3564L5.51033 15.3615L5.50384 15.3503ZM7.1642 17.3325L7.18001 17.3513L7.20134 17.3637L7.1642 17.3325ZM9.41681 18.6428L9.43529 18.6534L9.45638 18.6572L9.41681 18.6428ZM11.9645 19.0994L12.0001 19.1057L12.0357 19.0994L12 19.0995L11.9645 19.0994ZM14.5435 18.6572L14.5647 18.6535L14.5832 18.6427L14.5435 18.6572ZM16.7986 17.3637L16.8199 17.3514L16.8357 17.3326L16.7986 17.3637ZM18.4898 15.3613L18.4961 15.3504L18.4939 15.3564L18.4898 15.3613ZM18.4822 12.0845C18.2341 15.4478 15.4267 18.0995 12 18.0995C10.9617 18.0995 9.98033 17.8561 9.10974 17.4232L10.8618 14.376C11.2128 14.5201 11.5971 14.5995 12 14.5995C13.4917 14.5995 14.7292 13.5107 14.961 12.0845H18.4822ZM18.4799 11.0845H14.956C14.7118 9.67301 13.4812 8.59949 12 8.59949C11.6313 8.59949 11.2781 8.66601 10.9518 8.7877L9.17921 5.7418C10.0324 5.33019 10.9893 5.09949 12 5.09949C15.4165 5.09949 18.2174 7.73538 18.4799 11.0845ZM8.31473 6.24444L10.0865 9.2889C9.42274 9.83917 9 10.67 9 11.5995C9 12.4941 9.39161 13.2973 10.0128 13.8469L8.2514 16.9103C6.58681 15.7332 5.5 13.7933 5.5 11.5995C5.5 9.378 6.61443 7.41679 8.31473 6.24444ZM12 9.59949C10.8954 9.59949 10 10.4949 10 11.5995C10 12.7041 10.8954 13.5995 12 13.5995C13.1046 13.5995 14 12.7041 14 11.5995C14 10.4949 13.1046 9.59949 12 9.59949Z"
    />
  </Svg>
);

export const IconApple = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M20.3 17.4a11.4 11.4 0 01-2.6 3.8c-.5.5-1.2.8-1.8.8-.5 0-1-.2-1.8-.4a5 5 0 00-1.8-.4c-.6 0-1.3 0-2 .4l-1.6.4c-.6 0-1.3-.3-1.9-.8-.4-.4-1-1-1.5-1.9a12.6 12.6 0 01-2.3-7 7 7 0 011-3.6A5.4 5.4 0 018.3 6a6 6 0 012 .5L12 7l1.8-.6c.9-.3 1.7-.5 2.3-.4a5 5 0 014 2 4.4 4.4 0 00-2.3 4.1c0 1.3.5 2.5 1.4 3.3.5.4 1 .8 1.5 1l-.4 1zm-4-16c0 1-.4 2-1.2 3-1 1-2 1.7-3.2 1.6v-.4a4.7 4.7 0 012.7-4C15 1 15.6.9 16.1.9v.4z" />
  </Svg>
);

export const IconTelegram = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path opacity=".5" d="M9.9 19c-.6 0-.5-.3-.7-.8l-1.6-5.1 10-6 1.2.2-1 2.6-7.9 9z" />
    <path d="M10.2 14.8l6.8 5c.8.3 1.3.1 1.5-.8l2.8-12.6c.3-1.1-.4-1.6-1.2-1.3L4 11.1c-1.2.5-1.1 1.1-.2 1.4l4.1 1.2 9.7-5.9c.5-.2.9 0 .5.2L10.2 15z" />
  </Svg>
);

export const IconYoutube = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path opacity=".3" clipRule="evenodd" d="M14.8 12.1l-5-3.4 5.6 3.1-.6.3z" />
    <path
      clipRule="evenodd"
      d="M9.8 14.6V8.7l5.6 3-5.6 3zM20.9 6c-.7-.7-1.6-.8-2-.8-2.8-.2-7-.2-7-.2s-4.1 0-7 .2c-.3 0-1.2 0-2 .8-.5.6-.7 2-.7 2L2 11.2v1.5c0 1.7.2 3.3.2 3.3s.2 1.3.8 2c.7.7 1.7.7 2.2.8l6.7.2s4.2 0 7-.2c.4 0 1.3 0 2-.9.6-.6.8-2 .8-2l.2-3.2v-1.5L21.7 8s-.2-1.4-.8-2z"
    />
  </Svg>
);

export const IconUtmedia = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M16.4 14.9a8.3 8.3 0 01-6.2 3c-4 0-6.2-2.3-6.2-6V5h3.6v6.2c0 2.7 1 3.6 3.7 3.6 1.8 0 3.8-.7 5-1.5V5H20v12.7h-3.6v-2.8z" />
  </Svg>
);

export const IconTwitter = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M22.9 6c-.7.3-1.5.5-2.4.6.9-.5 1.5-1.3 1.8-2.3-.8.5-1.6.8-2.6 1a4.1 4.1 0 00-7 3.8c-3.4-.2-6.4-1.8-8.4-4.3a4.1 4.1 0 001.3 5.5 4 4 0 01-1.9-.5c0 2 1.4 3.7 3.3 4A4 4 0 015 14c.6 1.7 2 2.9 3.9 2.9a8.2 8.2 0 01-6.1 1.7 11.6 11.6 0 0018-10.4c.7-.6 1.4-1.3 2-2.2z" />
  </Svg>
);

export const IconLanguageEs = (props: SvgProps) => (
  <Svg viewBox="0 0 18 18" {...props}>
    <path d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18z" fill="#EEBF42" />
    <path
      d="M.936 5A9 9 0 0 1 9 0a9 9 0 0 1 8.064 5H.936zm16.128 8A9 9 0 0 1 9 18a9 9 0 0 1-8.064-5h16.128z"
      fill="#B02827"
    />
  </Svg>
);

export const IconLanguageEn = (props: SvgProps) => (
  <Svg viewBox="0 0 18 18" {...props}>
    <path d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18z" fill="#1F49A8" />
    <path
      d="M1.709 3.722L6.987 9 1.71 14.278a9.052 9.052 0 0 0 2.013 2.012L9 11.013l5.278 5.277a9.051 9.051 0 0 0 2.012-2.012L11.012 9l5.279-5.278a9.05 9.05 0 0 0-2.013-2.013L9 6.988 3.72 1.709A9.052 9.052 0 0 0 1.71 3.722z"
      fill="#fff"
    />
    <path
      d="M3.32 15.98a.922.922 0 0 1 .023.019L9 10.34l5.657 5.657.026-.02c.296-.24.576-.5.84-.777L9.7 9.641 16 3.34c-.25-.309-.52-.6-.809-.874l-6.19 6.19-6.192-6.19A9.055 9.055 0 0 0 2 3.34l6.3 6.3-5.822 5.56c.264.277.545.538.842.78z"
      fill="#C8102E"
    />
    <path
      d="M11 17.777A8.996 8.996 0 0 1 9 18a8.995 8.995 0 0 1-2-.223V11H.223A9.022 9.022 0 0 1 0 9c0-.688.077-1.357.223-2H7V.223A8.996 8.996 0 0 1 9 0c.688 0 1.357.076 2 .223V7h6.777c.146.643.223 1.313.223 2 0 .688-.077 1.357-.223 2H11v6.777z"
      fill="#fff"
    />
    <path
      d="M10 17.945V10h7.945a9.146 9.146 0 0 0 0-2H10V.055A8.901 8.901 0 0 0 9 0c-.338 0-.672.018-1 .055V8H.055a9.138 9.138 0 0 0 0 2H8v7.945c.328.037.662.055 1 .055.338 0 .672-.018 1-.055z"
      fill="#C8102E"
    />
  </Svg>
);

export const IconLanguageRu = (props: SvgProps) => (
  <Svg viewBox="0 0 18 18" {...props}>
    <path d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18z" fill="#4C9DFF" />
    <path d="M.512 6a9.004 9.004 0 0 1 16.976 0H.512z" fill="#fff" />
    <path d="M17.488 12A9.004 9.004 0 0 1 .512 12h16.976z" fill="#D0021B" />
    <path
      d="M9 17.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zM18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0z"
      fill="#000"
      fillOpacity=".15"
    />
  </Svg>
);

export const IconGooglePlay = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <path d="M3.15554 12.036C3.15554 9.1208 3.15554 6.20008 3.15554 3.28493C3.15554 2.92888 3.2223 2.60065 3.47821 2.32804C3.57835 2.22234 3.64511 2.19453 3.7675 2.31692C5.73134 4.3197 7.69518 6.31691 9.66457 8.31413C10.9386 9.61037 12.2125 10.901 13.4921 12.1917C13.6145 12.3141 13.6256 12.3809 13.4977 12.5144C10.3711 15.6243 7.24454 18.7397 4.12911 21.8607C3.93996 22.0498 3.80645 22.0332 3.62286 21.8885C3.28906 21.6326 3.16111 21.2877 3.16111 20.876C3.16111 19.1458 3.1611 17.4212 3.15554 15.691C3.14998 14.4782 3.14998 13.2599 3.15554 12.036C3.14998 12.036 3.14998 12.036 3.15554 12.036Z" />
    <path d="M4.2738 2C4.51302 2 4.67992 2.06676 4.84125 2.15577C8.83568 4.39221 12.8301 6.63421 16.8245 8.86508C17.0081 8.96522 17.0026 9.02641 16.8635 9.1655C15.9678 10.0445 15.0832 10.9291 14.1987 11.8192C14.1041 11.9138 14.0429 11.9694 13.915 11.8414C10.7383 8.59804 7.55613 5.36578 4.37394 2.12796C4.35169 2.10014 4.32944 2.06676 4.2738 2Z" />
    <path d="M5.16943 21.7949C8.0679 18.863 10.9719 15.9367 13.8648 12.9993C14.0428 12.8157 14.1263 12.8435 14.2876 13.0104C15.022 13.7782 15.7675 14.5292 16.5185 15.2803C16.652 15.4138 16.6632 15.4638 16.4851 15.564C12.7633 17.6001 9.04147 19.6474 5.3252 21.6892C5.25845 21.717 5.19725 21.7726 5.16943 21.7949Z" />
    <path d="M21.7315 12.12C21.7204 12.4482 21.5646 12.6819 21.331 12.8543C21.1585 12.9823 20.9638 13.088 20.7746 13.1937C19.6508 13.8168 18.5215 14.4343 17.3977 15.0574C17.2475 15.1408 17.1585 15.1408 17.0305 15.0073C16.2294 14.1839 15.4228 13.3606 14.6161 12.5483C14.4993 12.4315 14.4937 12.3648 14.6161 12.2479C15.5618 11.3189 16.502 10.3787 17.4367 9.43847C17.5479 9.32721 17.6258 9.31608 17.7649 9.39397C18.8776 10.0226 19.9958 10.6457 21.1084 11.2688C21.4478 11.4635 21.7148 11.7139 21.7315 12.12Z" />
  </Svg>
);
